import React, { useState, useEffect } from "react";
import { FiLogOut, FiKey } from "react-icons/fi";
import { Link, useNavigate ,useLocation} from "react-router-dom";
import logo from "../assets/images/logo_2.png";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function AddClient() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    language: "Japanese (JP)",
    mt5_account_number: "",
    mt5_account_id: "",
    account_type: "",
  });
  const [darkMode, setDarkMode] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setForm({
      name: "",
      email: "",
      password: "",
      language: "Japanese (JP)",
      mt5_account_number: "",
      mt5_account_id: "",
      account_type: "",
    });
  };

  const handleCopy = () => {
    const credentials = `Email: ${form.email}\nPassword: ${form.password}`;
    navigator.clipboard.writeText(credentials);
    alert("Credentials copied to clipboard");
  };
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const generatePassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0; i < 12; i++) {
      password += charset[Math.floor(Math.random() * charset.length)];
    }
    setForm(prev => ({ ...prev, password }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASE_URL}/api/signup`, {
        name: form.name,
        email: form.email,
        password: form.password,
        language: form.language,
        mt5_account_number: form.mt5_account_number,
        mt5_account_id: form.mt5_account_id,
        account_type: form.account_type,
      });

      if (res.data.success) {
        alert("✅ Client added successfully");
        handleReset();
      } else {
        alert("❌ Failed to add client");
      }
    } catch (err) {
      console.error("Signup error:", err);
      alert("❌ Server error while adding client");
    }
  };

  return (
    <div className={darkMode ? "min-h-screen bg-[#0B0F2B] text-white" : "min-h-screen bg-white text-black"}>
      {/* Mobile Header */}
      {isMobile && (
        <div className={`w-full px-4 py-3 flex justify-between items-center ${darkMode ? "bg-[#13162C]" : "bg-gray-100"} sticky top-0 z-50`}>
          <div className="flex items-center gap-2">
            <img src={logo} className="h-8" alt="Logo" />
            <h1 className={`text-lg font-bold ${darkMode ? "text-white" : "text-black"}`}>Add Client</h1>
          </div>
          <div className="flex items-center gap-2">
            <label className="inline-flex relative items-center cursor-pointer">
              <input
                type="checkbox"
                checked={darkMode}
                onChange={() => setDarkMode(!darkMode)}
                className="sr-only peer"
              />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <button onClick={handleLogout} className="bg-red-600 p-2 rounded text-sm">
              <FiLogOut className="text-white" />
            </button>
          </div>
        </div>
      )}

      {/* Desktop Header */}
      {!isMobile && (
        <nav className={darkMode ? "w-full px-6 py-4 flex justify-between items-center bg-[#13162C] shadow-md sticky top-0 z-50" : "w-full px-6 py-4 flex justify-between items-center bg-gray-100 shadow-md sticky top-0 z-50"}>
  <div className="flex items-center gap-3">
    <img src={logo} className="h-10" alt="Logo" />
    <h1 className="text-2xl font-bold text-white">Account Dashboard</h1>
  </div>
  <div className="flex items-center gap-4 flex-wrap justify-center w-full max-w-[700px]">
    <Link to="/dashboard">
      <button className={`px-3 py-1 rounded text-sm transition ${location.pathname === '/dashboard' ? 'bg-[#1FB0FF] hover:bg-[#1597d6]' : darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-300'}`}>
        Dashboard
      </button>
    </Link>
    <Link to="/AddClient">
      <button className={`px-3 py-1 rounded text-sm transition ${location.pathname === '/AddClient' ? 'bg-[#1FB0FF] hover:bg-[#1597d6]' : darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-300'}`}>
        Add Client
      </button>
    </Link>
    <Link to="/Viewclients">
      <button className={`px-3 py-1 rounded text-sm transition ${location.pathname === '/Viewclients' ? 'bg-[#1FB0FF] hover:bg-[#1597d6]' : darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-300'}`}>
        View/Edit Clients
      </button>
    </Link>
    <Link to="/AlertsSettings">
      <button className={`px-3 py-1 rounded text-sm transition ${location.pathname === '/AlertsSettings' ? 'bg-[#1FB0FF] hover:bg-[#1597d6]' : darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-300'}`}>
        Alerts Settings
      </button>
    </Link>
  </div>
  <div className="flex items-center gap-2">
    <span className="text-sm">{darkMode ? "🌙" : "☀️"}</span>
    <label className="inline-flex relative items-center cursor-pointer">
      <input
        type="checkbox"
        checked={darkMode}
        onChange={() => setDarkMode(!darkMode)}
        className="sr-only peer"
      />
      <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
    </label>
    <button onClick={handleLogout} className="bg-red-600 px-4 py-2 rounded text-sm flex items-center gap-1">
      <FiLogOut /> Logout
    </button>
  </div>
</nav>
      )}

      {/* Mobile Menu */}
      {isMobile && (
        <div className={`w-full px-2 py-2 flex justify-between items-center ${darkMode ? "bg-gray-900" : "bg-gray-200"} shadow-sm`}>
          <Link to="/dashboard" className="text-center px-2 py-1 text-sm">
            Dashboard
          </Link>
          <Link to="/AddClient" className="text-center px-2 py-1 text-sm">
            Add Client
          </Link>
          <Link to="/Viewclients" className="text-center px-2 py-1 text-sm">
            View Clients
          </Link>
          <Link to="/AlertsSettings" className="text-center px-2 py-1 text-sm">
            Alerts
          </Link>
        </div>
      )}

      {/* Form Section */}
      <div className={`flex justify-center ${isMobile ? 'py-6 px-4' : 'py-10 px-4'}`}>
        <div className={`w-full ${isMobile ? 'max-w-md' : 'max-w-3xl'} rounded-lg ${isMobile ? 'px-4 py-6' : 'px-8 py-10'} border ${
          darkMode ? "bg-[#0F1231] border-blue-900 text-white" : "bg-gray-100 border-gray-300 text-black"
        }`}>
          <h2 className={`text-center ${isMobile ? 'text-2xl' : 'text-3xl'} font-bold mb-6 ${
            darkMode ? "text-green-400" : "text-green-700"
          }`}>Add New Client</h2>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4">
              <label className={`${isMobile ? 'text-sm' : ''} ${darkMode ? "text-blue-400" : "text-blue-700"}`}>Client Name:</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter Client Name"
                className={`px-4 py-2 rounded ${isMobile ? 'text-sm' : ''} ${
                  darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                }`}
              />

              <label className={`${isMobile ? 'text-sm' : ''} ${darkMode ? "text-blue-400" : "text-blue-700"}`}>Client Email ID:</label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Client Email ID"
                className={`px-4 py-2 rounded ${isMobile ? 'text-sm' : ''} ${
                  darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                }`}
              />

              <label className={`${isMobile ? 'text-sm' : ''} ${darkMode ? "text-blue-400" : "text-blue-700"}`}>Password:</label>
              <div className="relative">
                <input
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Enter password for the user portal"
                  className={`w-full px-4 py-2 pr-10 rounded ${isMobile ? 'text-sm' : ''} ${
                    darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                  }`}
                />
                <button
                  type="button"
                  onClick={generatePassword}
                  className={`absolute right-2 top-2 ${
                    darkMode ? "text-green-400" : "text-green-600"
                  }`}
                >
                  <FiKey />
                </button>
              </div>

              <label className={`${isMobile ? 'text-sm' : ''} ${darkMode ? "text-blue-400" : "text-blue-700"}`}>Language:</label>
              <select
                name="language"
                value={form.language}
                onChange={handleChange}
                className={`px-4 py-2 rounded ${isMobile ? 'text-sm' : ''} ${
                  darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                }`}
              >
                <option>Japanese (JP)</option>
                <option>English (EN)</option>
                <option>French (FR)</option>
                <option>German (DE)</option>
                <option>Spanish (ES)</option>
                <option>Chinese (ZH)</option>
                <option>Korean (KR)</option>
                <option>Arabic (AR)</option>
                <option>Russian (RU)</option>
                <option>Portuguese (PT)</option>
                <option>Italian (IT)</option>
              </select>

              <label className={`${isMobile ? 'text-sm' : ''} ${darkMode ? "text-blue-400" : "text-blue-700"}`}>MT5 Account:</label>
              <div className={`flex ${isMobile ? 'flex-col gap-2' : 'gap-2'}`}>
                <input
                  name="mt5_account_number"
                  value={form.mt5_account_number}
                  onChange={handleChange}
                  placeholder="MT5 Acc. No"
                  className={`px-4 py-2 rounded ${isMobile ? 'text-sm w-full' : 'w-1/3'} ${
                    darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                  }`}
                />
                <input
                  name="mt5_account_id"
                  value={form.mt5_account_id}
                  onChange={handleChange}
                  placeholder="Account ID"
                  className={`px-4 py-2 rounded ${isMobile ? 'text-sm w-full' : 'w-1/3'} ${
                    darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                  }`}
                />
                <select
                  name="account_type"
                  value={form.account_type}
                  onChange={handleChange}
                  className={`px-4 py-2 rounded ${isMobile ? 'text-sm w-full' : 'w-1/3'} ${
                    darkMode ? "bg-[#1F233F] text-white" : "bg-white text-black border border-gray-300"
                  }`}
                >
                  <option value="">Account Type</option>
                  <option value="Demo">Demo</option>
                  <option value="Real">Real</option>
                  <option value="Cent">Cent</option>
                </select>
              </div>
            </div>

            <div className={`flex ${isMobile ? 'flex-col gap-3' : 'gap-4'} justify-start mt-6`}>
              <button type="submit" className="bg-green-600 px-4 py-2 rounded text-white">
                ✔ Add Client
              </button>
              <button type="button" onClick={handleReset} className="bg-red-600 px-4 py-2 rounded text-white">
                ↺ Reset
              </button>
              <button type="button" onClick={handleCopy} className="bg-blue-600 px-4 py-2 rounded text-white">
                📋 Copy credentials
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}